var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solo-game"},[_c('SentimentForm',{on:{"sentiment":function (sentiment) { return _vm.saveSentiment(sentiment); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }